export const TaskType = [{
    id: 0,
    name: ''
}, {
    id: 1,
    name: 'Hibabejelentés'
}, {
    id: 2,
    name: 'Fejlesztési javaslat'
}, {
    id: 3,
    name: 'Fejlesztési napló'
}];